<template>
  <v-dialog v-model="showDialogForm" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('Position') }}</span>
      </v-card-title>
      <v-card-text>
        <PositionForm :errors="violations" :values="item" :loading="isLoading" ref="positionDialogForm"/>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="showDialogForm = false">{{ $t('Close') }}</v-btn>
        <v-spacer/>
        <v-btn class="mainAccent lighten-3" dark @click="resetForm">{{ $t('Reset') }}</v-btn>
        <v-btn color="primary" @click="sendForm">{{ $t('Submit') }}</v-btn>
      </v-card-actions>
    </v-card>
    <Loading :visible="isLoading"/>
  </v-dialog>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';
import PositionForm from './Form';
import NotificationMixin from '../../mixins/NotificationMixin';
import Loading from "@/components/Loading";
import {mapActions, mapGetters} from "vuex";
import DialogMixin from "@/mixins/DialogMixin";

const servicePrefix = 'Position';

const {mapFields} = createHelpers({
  getterType: 'position/getField',
  mutationType: 'position/updateField'
});

export default {
  name: "PositionDialog",
  servicePrefix,
  mixins: [NotificationMixin, DialogMixin],
  components: {
    Loading,
    PositionForm,
  },
  props: {
    value: Boolean,
    handleCreated: {
      type: Function,
      required: false
    },
    handleUpdated: {
      type: Function,
      required: false
    },
    positionItem: {
      type: Object,
      required: false,
    },
    isUpdateForm: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    isCreateForm: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      item: {},
      createMessage: this.$t("successfullyCreated"),
      updateMessage: this.$t("successfullyUpdated"),
    }
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations', 'updated', 'byId']),
    ...mapGetters('position', ['find']),
    showDialogForm: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
  },
  methods: {
    ...mapActions('position', {
      create: 'create',
      update: 'update',
      resetData: 'resetData',
      retrieve: 'load',
    }),
    sendForm() {
      if (this.isValidForm()) {
        let model = this.$refs.positionDialogForm.$v.item.$model;
        if (this.handleUpdated && model['@id']) {
          this.update(model);
        }
        if (this.handleCreated && !model['@id']) {
          this.create(model);
        }
      }
    },
    reset() {
      this.$refs.positionDialogForm.$v.$reset();
    },
    resetForm() {
      this.item = {...this.positionItem};
      if (this.$refs['positionDialogForm']) {
        this.$refs.positionDialogForm.$v.$reset();
      }
    },
    isValidForm() {
      this.$refs.positionDialogForm.$v.$touch();
      return !this.$refs.positionDialogForm.$v.$invalid;
    },
  },
  watch: {
    positionItem() {
      this.item = {...this.positionItem};
      this.resetForm();
    },
    created(created) {
      if (!created) {
        return;
      }
      this.showMessage(this.createMessage);
      if (this.handleCreated) {
        this.handleCreated(created);
        this.showDialogForm = false;
      }
    },
    updated(updated) {
      this.showMessage(this.updateMessage);
      if (this.handleUpdated) {
        this.handleUpdated(updated);
        this.showDialogForm = false
      }
    },
    error(message) {
      message && this.showError(message);
    },
  },
  created() {
    this.item = {...this.positionItem};
  }
}
</script>
